
    /**
    * 商品提报供应商名称是否存在
    * 
    **/
    
    // @ts-nocheck
    import request from '../utils/http'
    type Serve<T, G> = (data?: T) => Promise<G>
    export class IReqApiCheckSupplyNameForSubmit25752 {
  /**
   * (String)
   */
  supplierName: string | number;
}
    /**
 * Response<OfficalCheckNameForSubmitResp> :Response
 */
export class IResApiCheckSupplyNameForSubmit25752 {
  message?: {};
  code?: {};
  /**
   * OfficalCheckNameForSubmitResp
   */
  data?: {
    /**
     * 0未入驻1已入驻
     */
    exist?: {};
  };
}
    const http: Serve<IReqApiCheckSupplyNameForSubmit25752, IResApiCheckSupplyNameForSubmit25752> = (data?) =>  request({
      method: 'GET',
      url: '/api/check/supplyName/forSubmit',
      params: data
    }) 
    export default http